import React from 'react';
import TextField from '@material-ui/core/TextField';
import { FieldErrors as ReactHookFieldErrors, FieldValues } from 'react-hook-form';

import FieldErrors from '../field-errors/field-errors';
import FieldOverlay from '../../atoms/field-overlay/field-overlay';

type TextFieldDropDownProps = {
    id: string;
    errors: ReactHookFieldErrors<FieldValues>;
    overlay?: JSX.Element;
    textFieldOpts: Record<string, any>;
    children: (boolean | JSX.Element)[];
    value: any;
    label: string;
    helperText?: string;
};

export default function TextFieldDropdown({
    id,
    errors,
    overlay,
    textFieldOpts,
    children,
    value,
    label,
    helperText,
}: TextFieldDropDownProps) {
    return (
        <>
            <TextField
                select
                fullWidth
                value={value}
                label={label}
                variant='outlined'
                {...textFieldOpts}
                helperText={helperText}
            >
                {children}
            </TextField>
            <FieldErrors fieldId={id} errors={errors} />
            <FieldOverlay>{overlay}</FieldOverlay>
        </>
    );
}
